import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        username: null,
        isAuthenticated: false
    },
    reducers: {
        LOGIN: (state, action) => {
            state.username = action.payload;
            state.isAuthenticated = true;
            localStorage.setItem('Codeium__Username', JSON.stringify(action.payload));
        },

        LOGOUT: (state) => {
            state.username = null;
            state.isAuthenticated = false;
            localStorage.removeItem("Codeium__Username");
        }
    }
})

export const { LOGIN, LOGOUT } = authSlice.actions;

export const autoLogin = () => dispatch => {
    let username = localStorage.getItem('Codeium__Username');
    if(username) {
        username = JSON.parse(username);
        dispatch(LOGIN(username))
    }
    let deleteInfo = localStorage.getItem('Codeium__deleteDetails');
    if(deleteInfo) {
        localStorage.removeItem('cart');
        localStorage.removeItem('Codeium__Discount');
        localStorage.removeItem('Codeium__transaction');
        localStorage.removeItem('Codeium__shippingDetails');
        localStorage.removeItem('Codeium__deleteDetails');
    }
}

export const selectUserData = state => state.auth;

export default authSlice.reducer;